import { CSSClassnames } from "./ts/enum";

export const isElementOpened = (elem: HTMLElement) =>
  elem.classList.contains(CSSClassnames.OPENED);
